export default "__VITE_ASSET__CPomP43R__"